export const InitialAppState = {
    error: false,
    returnTo: ''
};
